import { random, round2Str } from "../helpers/helpers";
import { thMeterSensorRegistry } from "./thMeterSensorRegistry";

// -------------------------
// helpers
// -------------------------
const daysInMonth = (year, month) =>
    new Date(year, month, 0).getDate(); // month = 1-12

export const generateThChartMonthlyDemo = ({
                                               meter_id,
                                               sensor_name, // sensor_id
                                               year,
                                               month,
                                           }) => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;
    const currentDay = now.getDate();

    // -------------------------
    // Resolve meter & sensor
    // -------------------------
    const meterEntry = thMeterSensorRegistry.find(
        (m) => m.meter_id === Number(meter_id)
    );

    const sensorEntry = meterEntry?.sensors.find(
        (s) => s.sensor_id === Number(sensor_name)
    );

    const [minTempRange, maxTempRange] =
    sensorEntry?.temp_range || [20, 26];
    const [minHumiRange, maxHumiRange] =
    sensorEntry?.humi_range || [45, 60];

    // -------------------------
    // Days to generate
    // -------------------------
    const totalDays = daysInMonth(year, month);

    const maxDay =
        year === currentYear && month === currentMonth
            ? currentDay
            : totalDays;

    // Base values (stable)
    let baseTemp = random(minTempRange + 1, maxTempRange - 1);
    let baseHumi = random(minHumiRange + 3, maxHumiRange - 3);

    const daily_energy_data = [];

    for (let day = 1; day <= maxDay; day++) {
        // Gentle drift
        baseTemp += random(-0.3, 0.3);
        baseHumi += random(-0.6, 0.6);

        const avgTemp = baseTemp + random(-0.4, 0.4);
        const maxTemp = avgTemp + random(3, 6);
        const minTemp = avgTemp - random(3, 6);

        const avgHumi = baseHumi + random(-1.5, 1.5);
        const maxHumi = avgHumi + random(6, 10);
        const minHumi = avgHumi - random(6, 10);

        daily_energy_data.push({
            day,

            avg_temp: round2Str(avgTemp),
            max_temp: round2Str(
                Math.min(maxTemp, maxTempRange + 5)
            ),
            min_temp: round2Str(
                Math.max(minTemp, minTempRange - 5)
            ),

            avg_humidity: round2Str(avgHumi),
            max_humidity: round2Str(
                Math.min(maxHumi, maxHumiRange + 15)
            ),
            min_humidity: round2Str(
                Math.max(minHumi, minHumiRange - 15)
            ),
        });
    }

    return {
        year: Number(year),
        month: Number(month),
        daily_energy_data,
    };
};
